import { CreateSellTreezRequest } from '@/models/sellTreez'

import { FormData } from '../data/types'

export const sanitizeFormData = (data: FormData): CreateSellTreezRequest => ({
  ...data,
  events: {
    source: JSON.parse(data.events.source),
    detailType: JSON.parse(data.events.detailType),
    externalAccountId: JSON.parse(data.events.externalAccountId),
  },
})
